var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSms = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3359 2.33325H4.66927C2.66927 2.33325 1.33594 3.33325 1.33594 5.66659V10.3333C1.33594 12.6666 2.66927 13.6666 4.66927 13.6666H11.3359C13.3359 13.6666 14.6693 12.6666 14.6693 10.3333V5.66659C14.6693 3.33325 13.3359 2.33325 11.3359 2.33325ZM11.6493 6.39325L9.5626 8.05992C9.1226 8.41325 8.5626 8.58659 8.0026 8.58659C7.4426 8.58659 6.87594 8.41325 6.4426 8.05992L4.35594 6.39325C4.1426 6.21992 4.10927 5.89992 4.27594 5.68659C4.44927 5.47325 4.7626 5.43325 4.97594 5.60659L7.0626 7.27325C7.56927 7.67992 8.42927 7.67992 8.93594 7.27325L11.0226 5.60659C11.2359 5.43325 11.5559 5.46659 11.7226 5.68659C11.8959 5.89992 11.8626 6.21992 11.6493 6.39325Z",
    fill: "#7E7E80"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSms, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sms.1e5390f7.svg";
export { ForwardRef as ReactComponent };